import React from 'react';
import { getIconStepSurvey } from '../utils/IconUtils';

export const IconChip = ({step}) => {
  return (
    <div>
      <span className={`chipicon ${getIconStepSurvey(step)}`} />
    </div>
  );
};